import React from 'react';
import PropTypes from 'prop-types';
import { v1 as uuid } from 'uuid';

import renderLocale from '../../helpers/renderLocale';
import messages from '../../../assets/messages';
import convertSnakeToCamelCase from '../../utils/convertSnakeToCamelCase';
import iconMap from '../../constants/iconMap';
import {
  FlexContainer,
  BadgeIcon,
  BadgeName,
  ReactTooltipStyled
} from './Styles';

const propTypes = {
  badges: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.number),
    PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        type: PropTypes.string
      })
    )
  ])
};

const defaultProps = {
  badges: []
};

const BadgeWithTooltip = ({ badges }) => {
  const locale = renderLocale();
  const getBadgeMessageKey = s => {
    return `badges.${convertSnakeToCamelCase(s)}`;
  };

  const getBadgeDescriptionKey = s => {
    return `badges.${convertSnakeToCamelCase(s)}.description`;
  };

  return (
    <>
      {badges &&
        badges.length > 0 &&
        badges.map(badge => {
          let badgeId;
          let badgeDescriptionKey;
          let badgeMessageKey;

          if (Number.isInteger(badge)) {
            badgeId = badge;
          } else {
            const { id, type } = badge;
            badgeId = id;
            badgeDescriptionKey = getBadgeDescriptionKey(type);
            badgeMessageKey = getBadgeMessageKey(type);
          }

          return (
            <React.Fragment key={uuid()}>
              <FlexContainer key={badgeId}>
                <BadgeIcon
                  src={iconMap[badgeId]}
                  alt={messages[locale][badgeDescriptionKey]}
                  data-tip
                  data-for="badgeTooltip"
                />

                {badgeMessageKey && (
                  <BadgeName>{messages[locale][badgeMessageKey]}</BadgeName>
                )}
              </FlexContainer>
              <ReactTooltipStyled
                id="badgeTooltip"
                key={`badgeTooltip_${uuid()}`}
                arrowColor="transparent"
                place="bottom"
              >
                <span>
                  {messages[locale][`sharedBadges.tooltip.${badgeId}`]}
                </span>
              </ReactTooltipStyled>
            </React.Fragment>
          );
        })}
    </>
  );
};

BadgeWithTooltip.propTypes = propTypes;
BadgeWithTooltip.defaultProps = defaultProps;

export default React.memo(BadgeWithTooltip);
